<template>
  <div class="add-order">
    <!--附加订单类型  -->
    <AttachTypeField :min-ticks="minTicks" />

    <!--止盈价  -->
    <AttachProfitPriceField v-if="showProfitField" :min-ticks="minTicks" />
    <!-- 有效期 -->
    <OrderTimeInForceField
      v-if="showProfitField"
      add-order="profit"
      :list="availableTimeInForce"
    />
    <!--盘后交易  -->
    <OrderRthField v-if="showProfitField && showRthField" add-order="profit" />

    <!--止损价  -->
    <AttachLossPriceField v-if="showLossField" :min-ticks="minTicks" />
    <!--有效期  -->
    <OrderTimeInForceField
      v-if="showLossField"
      add-order="loss"
      :list="availableTimeInForce"
    />
    <!--盘后交易  -->
    <OrderRthField v-if="showLossField && showRthField" add-order="loss" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import AttachTypeField from './OrderFields/AttachTypeField'
import AttachProfitPriceField from './OrderFields/AttachProfitPriceField.vue'
import AttachLossPriceField from './OrderFields/AttachLossPriceField.vue'
import OrderTimeInForceField from './OrderFields/TimeInForceField.vue'
import OrderRthField from './OrderFields/RthField.vue'
import { ORDER_TYPE } from 'const/trade'
import { MARKET_TYPE, SEC_TYPE } from 'const/stock'

export default {
  name: 'AddOrder',
  components: {
    AttachTypeField,
    OrderRthField,
    OrderTimeInForceField,
    AttachProfitPriceField,
    AttachLossPriceField
  },
  data() {
    return {
      type: 'NO'
    }
  },
  computed: {
    ...mapGetters(['tradeRequest']),
    contract() {
      return this.tradeRequest.contract
    },
    order() {
      return this.tradeRequest.order
    },
    stock() {
      return this.tradeRequest.stock
    },
    minTicks() {
      return this.contract ? this.contract.tickSizes : []
    },
    availableTimeInForce() {
      return this.contract ? this.contract.availableTimeInForce : []
    },
    showRthField() {
      return (
        this.stock.market === MARKET_TYPE.US &&
        this.stock.secType === SEC_TYPE.STK
      )
    },
    showProfitField() {
      return [ORDER_TYPE.BRACKETS, ORDER_TYPE.PROFIT].includes(
        this.order.attachOrderType
      )
    },
    showLossField() {
      return [ORDER_TYPE.BRACKETS, ORDER_TYPE.LOSS].includes(
        this.order.attachOrderType
      )
    }
  }
}
</script>
<style lang="less" scoped>
.add-order {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--special-color);
}
</style>
